import React from 'react';
import '../styles/NotFound.css';

class NotFound extends React.Component {
  render() {
    return (
      <h1 className="not-found-text">Página não encontrada</h1>
    );
  }
}

export default NotFound;
